export const getProfileCompletionName = (
  profile?: {
    firstName?: string | null;
    lastName?: string | null;
  } | null,
) => {
  const firstName = profile?.firstName?.trim() ?? "";
  const lastName = profile?.lastName?.trim() || firstName;

  return {
    firstName,
    lastName,
    fullName: [firstName, lastName === firstName ? "" : lastName]
      .filter(Boolean)
      .join(" "),
  };
};
